// AWS Configuration
// Replace these values with your actual AWS resource IDs after deployment

const config = {
  stage: import.meta.env.VITE_STAGE || 'dev',
  region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  userPoolId: import.meta.env.VITE_USER_POOL_ID || 'YOUR_USER_POOL_ID',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || 'YOUR_USER_POOL_CLIENT_ID',
  apiUrl: import.meta.env.VITE_API_URL || 'YOUR_API_URL',
  allowSignup: import.meta.env.VITE_ALLOW_SIGNUP === 'true',
  posthogKey: import.meta.env.VITE_POSTHOG_KEY || '',
  posthogHost: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
};

export default config;
